import { DynamicalStyles } from '@consts';
import { setupForDark } from '@theme';
import classNames from 'classnames';
import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';

export default function Textarea({
  value = null,
  disabled = false,
  placeholder = null,
  className = null,
  onChange,
  maxRows = 5,
  'data-testid': dataTestId
}: {
  value?: string;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  maxRows?: number;
  'data-testid'?: string;
}) {
  let extraProps: Record<string, any> = {};
  if (value !== null) {
    extraProps = {
      value: value
    };
  }
  if (placeholder) {
    extraProps = {
      ...extraProps,
      placeholder: placeholder
    };
  }

  return (
    <TextareaAutosize
      maxRows={maxRows}
      data-testid={dataTestId}
      className={classNames(
        'w-full',
        'outline-none',
        'P2R',
        'p-sm rounded-xs border-[1px]',
        'resize-none', // Prevent manual resizing since we're handling it
        DynamicalStyles.scrollbarStyles(),
        setupForDark('text-primary border-text-input-default bg-text-input-default'),
        setupForDark(
          'disabled:text-tertiary disabled:border-text-input-disabled disabled:bg-text-input-disabled'
        ),
        className
      )}
      onChange={onChange}
      disabled={disabled}
      {...extraProps}
    />
  );
}
